/* haiku-likes — the heart. One store, one event, every heart repaints from it.

   Store: localStorage "haiku:likes" → JSON array of product handles. Handle,
   not id, so a re-created product keeps its heart. Storage access is wrapped
   exactly as haiku-modes.js does it; when blocked the set lives in memory.

   Event: document "haiku:likes" { detail: { handles } } after every change,
   and once at boot with { handles, ready: true } so a consumer that booted
   first can re-read. haiku-wardrobe.js listens for it (the liked view); so
   do all hearts, and the header's count (haiku-icons.js).

   Mounts: <span class="hl-mount" data-hl="<handle>" data-hl-title="<title>">
   emitted by Liquid where we own the markup (slide, preview group, product
   page). The homepage rail is a vendor snippet we do not edit, so hearts are
   injected there by selector, titled from the tile's .product-item__title.
   The title goes into the label ("Like this piece: <title>") — seventeen
   identical "Like this piece" buttons tell a screen reader nothing.

   Public: window.HaikuLikes.{ has(handle), toggle(handle), all() }. */
(function () {
  'use strict';

  var cfg = window.haikuLikesConfig || {};
  if (cfg.enabled === false) return;

  var d = document;
  var KEY = cfg.storageKey || 'haiku:likes';
  var mem = null;

  /* Whatever is in storage was written by some version of this file, or by
     hand: keep strings only, drop empties and repeats (first one wins, so the
     order a visitor liked things in survives). */
  function read() {
    if (mem) return mem;
    var v = null;
    try { v = JSON.parse(window.localStorage.getItem(KEY) || '[]'); } catch (e) { v = []; }
    mem = [];
    if (Array.isArray(v)) v.forEach(function (h) { if (typeof h === 'string' && h && mem.indexOf(h) === -1) mem.push(h); });
    return mem;
  }
  function write(list) {
    mem = list;
    try { window.localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) { /* blocked: memory only */ }
  }

  function has(handle) { return read().indexOf(handle) > -1; }
  function all() { return read().slice(); }
  function toggle(handle) {
    if (!handle) return false;
    var list = read().slice();
    var i = list.indexOf(handle);
    if (i > -1) list.splice(i, 1); else list.push(handle);
    write(list);
    var on = i === -1;
    d.dispatchEvent(new CustomEvent('haiku:likes', { detail: { handles: list.slice(), handle: handle, liked: on } }));
    return on;
  }

  window.HaikuLikes = { has: has, toggle: toggle, all: all };

  /* ---- hearts ------------------------------------------------------------ */
  function paint(btn) {
    var on = has(btn.dataset.hlHeart);
    var label = (on ? cfg.unlikeLabel : cfg.likeLabel) || (on ? 'Unlike' : 'Like');
    var title = btn.dataset.hlTitle;
    btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    btn.setAttribute('aria-label', title ? label + ': ' + title : label);
  }

  function makeHeart(handle, title) {
    var b = d.createElement('button');
    b.type = 'button';
    b.className = 'hl-heart';
    b.dataset.hlHeart = handle;
    if (title) b.dataset.hlTitle = title;
    /* The icon set's heart when haiku-icons is on the page (every template),
       the text glyph otherwise. */
    var t = d.querySelector('template[data-hi-tpl="heart"]');
    if (t && 'content' in t && t.content.firstElementChild) b.appendChild(t.content.firstElementChild.cloneNode(true));
    else b.innerHTML = '<span aria-hidden="true">&#9829;</span>';
    /* The rail's <css-slider> arms a drag on mousedown and PAGES on the first
       mousemove over 1px (component-css-slider.js), and haiku-row.js starts its
       own drag on pointerdown. Stopping only `click` let a press on the heart
       page the rail. A mouse or pen press that starts on the heart is the
       heart's.

       ⚠️ TOUCH IS NEVER STOPPED. Neither of those needs it: the slider binds its
       mouse drag only when the device has no touch (component-css-slider.js,
       the `ontouchstart` test), and haiku-row.js returns on pointerType
       'touch'. But the gallery's GSAP Observer listens for touchstart on
       WINDOW (it picks touch events whenever `ontouchstart` exists), so
       stopping it here killed any swipe that began on a heart — measured at
       1024x1366 with touch: 0px from the heart, -335px from the image. A tap
       still toggles: the click is its own event and is stopped below. */
    ['mousedown', 'pointerdown'].forEach(function (t) {
      b.addEventListener(t, function (e) { if (e.pointerType !== 'touch') e.stopPropagation(); }, { passive: true });
    });
    b.addEventListener('click', function (e) {
      // Slides and rail tiles open/navigate on click; the heart must not.
      e.preventDefault();
      e.stopPropagation();
      toggle(handle);
    });
    b.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') e.stopPropagation(); });
    paint(b);
    return b;
  }

  function fillMounts(root) {
    Array.prototype.forEach.call((root || d).querySelectorAll('.hl-mount[data-hl]'), function (m) {
      if (m.querySelector('.hl-heart')) return;
      m.appendChild(makeHeart(m.dataset.hl, m.dataset.hlTitle));
    });
  }

  /* Vendor rail tiles: derive the handle from the product link and add a mount
     as a SIBLING of the anchor (never inside it). */
  function injectRail() {
    Array.prototype.forEach.call(d.querySelectorAll('.products-slider .product-item'), function (tile) {
      if (tile.querySelector(':scope > .hl-mount')) return;
      var a = tile.querySelector('a[href*="/products/"]');
      if (!a) return;
      var m = (a.getAttribute('href') || '').match(/\/products\/([^/?#]+)/);
      if (!m) return;
      var mount = d.createElement('span');
      mount.className = 'hl-mount hl-mount--rail';
      mount.dataset.hl = m[1];
      var t = tile.querySelector('.product-item__title');
      var title = t ? t.textContent.replace(/\s+/g, ' ').trim() : '';
      if (title) mount.dataset.hlTitle = title;
      tile.appendChild(mount);
    });
  }

  /* haiku-motion.js (a deferred <head> script) scans for magnetic elements
     once, at its own boot — before any heart exists. Hand it the page again
     once they do; it skips what it already holds, and is a no-op when the
     magnet is off (reduced motion, no hover). Hearts only: an unnarrowed pass
     also magnetised late homepage elements the boot scan had left still. */
  function magnetise() {
    if (window.HaikuMotion && typeof window.HaikuMotion.attach === 'function') window.HaikuMotion.attach(d, '.hl-heart');
  }

  function repaintAll() {
    Array.prototype.forEach.call(d.querySelectorAll('.hl-heart'), paint);
  }

  /* Re-read from storage and tell everyone. The dispatch IS the repaint (the
     listener just above), and it is what haiku-wardrobe.js hears — repainting
     hearts alone would leave a `?liked=1` wardrobe showing the old set. Two ways the
     store changes under a live page: another tab writes it (`storage`; a null
     key is localStorage.clear()), or the page comes back from the bfcache
     after this tab changed it on another page (`pageshow` persisted). */
  function reread() {
    mem = null;
    d.dispatchEvent(new CustomEvent('haiku:likes', { detail: { handles: all() } }));
  }

  d.addEventListener('haiku:likes', repaintAll);
  window.addEventListener('storage', function (e) { if (e.key === KEY || e.key === null) reread(); });
  window.addEventListener('pageshow', function (e) { if (e.persisted) reread(); });
  d.addEventListener('shopify:section:load', function () { injectRail(); fillMounts(); magnetise(); });

  function boot() {
    injectRail();
    fillMounts();
    magnetise();
    // Consumers that booted before us (or read an empty store) re-read now.
    d.dispatchEvent(new CustomEvent('haiku:likes', { detail: { handles: all(), ready: true } }));
  }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', boot); else boot();
}());
